import { Dialog } from 'evergreen-ui';
import EditGuestForm from './EditGuestForm';
import { useRole } from '../contexts/RoleContext';

const EditGuestDialog = ({
    isShown,
    onClose,
    guest,
    fetchGuests
}) => {
    const { effectiveIsDirector: isDirector } = useRole();
    return (
        <Dialog
            isShown={isShown}
            title="Modifica ospite"
            onCloseComplete={onClose}
            hasFooter={false}
            shouldAutoFocus={false}
        >
            {guest && (
                <EditGuestForm
                    editedGuest={guest}
                    handleCancelEdit={onClose}
                    fetchGuests={fetchGuests}
                />
            )}
        </Dialog>
    );
};

export default EditGuestDialog;